(function () {
  'use strict';

  angular
    .module('web2print')
    .factory('CountrySelectionFactory', CountrySelectionFactory);

  CountrySelectionFactory.$inject = ['$http'];

  function CountrySelectionFactory ($http) {
    const service = {
      getCountries: getCountries
    };

    return service;

    function getCountries (language) {
      // TODO This function must be called on language change!
      console.log('running getCountries');

      const lang = language || 'sv';
      const market = pnTopbar.market.toLowerCase();

      const params = '?language=' + lang;

      const req = web2print.env.baseUrls[market] + params;
      return $http.get(req).then(function (response) {
        return response.data.countries;
      });
    }
  }
})();
